import { render, staticRenderFns } from "./show-results.vue?vue&type=template&id=5bfc847d&scoped=true&"
import script from "./show-results.vue?vue&type=script&lang=js&"
export * from "./show-results.vue?vue&type=script&lang=js&"
import style0 from "./show-results.vue?vue&type=style&index=0&id=5bfc847d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc847d",
  null
  
)

export default component.exports